import React from "react";
import RgeCard from "../components/RgeCard";

const Services = () => {
  return (
    <div id="Services">
      <h2 style={{ marginTop: "100px", textDecoration: "underline" }}>
        Nos Services:
      </h2>
      <div className="container mt-5">
        <div className="row justify-content-around">
          <div className="col-md-2 mb-3">
            <div className="text-center">
              <h3 style={{ fontSize: "25px", fontWeight: "680" }}>
                Ravalement de façades
              </h3>
            </div>
          </div>
          <div className="col-md-2 mb-3">
            <div className="text-center">
              <h3 style={{ fontSize: "25px", fontWeight: "680" }}>Crépis</h3>
            </div>
          </div>
          <div className="col-md-2 mb-3">
            <div className="text-center">
              <h3 style={{ fontWeight: "680" }}>Peinture</h3>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="text-center">
              <h3 style={{ fontWeight: "680" }}>Services d'isolation</h3>
            </div>
          </div>
        </div>
      </div>
      <h3 style={{ marginTop: "100px", textDecoration: "underline" }}>
        Notre travail qualifié RGE
      </h3>
      <RgeCard />
    </div>
  );
};

export default Services;
